import React, { ReactNode } from 'react';
import { Box } from '@heycater/design-system';
import Image from 'next/image';
import styled from 'styled-components';

type TrustedCustomer =
  | 'barmer'
  | 'dell'
  | 'infarm'
  | 'ebay'
  | 'hello-fresh'
  | 'audi';

interface Props {
  items?: TrustedCustomer[] | 'all';
}

function TrustedCustomers({ items = 'all' }: Props) {
  const customers: Record<TrustedCustomer, ReactNode> = {
    barmer: (
      <Box
        mx={{ xs: 4, lg: 5 }}
        my={2}
        width={{ xs: 74, md: 127 }}
        height={{ xs: 14, md: 20 }}
        position="relative"
      >
        <CustomerLogo
          alt="The logo of Barmer"
          src="/artifacts/images/homepage/trust-customer-icons/barmer.webp"
          layout="responsive"
          width="127"
          height="20"
        />
      </Box>
    ),
    dell: (
      <Box
        mx={{ xs: 4, lg: 5 }}
        my={2}
        width={{ xs: 35, md: 46 }}
        height={{ xs: 35, md: 46 }}
        position="relative"
      >
        <CustomerLogo
          alt="The logo of Dell"
          src="/artifacts/images/homepage/trust-customer-icons/dell.webp"
          layout="responsive"
          width="46"
          height="46"
        />
      </Box>
    ),
    infarm: (
      <Box
        mx={{ xs: 4, lg: 5 }}
        my={2}
        width={{ xs: 67, md: 103 }}
        height={{ xs: 12, md: 25 }}
        position="relative"
      >
        <CustomerLogo
          alt="The logo of Infarm"
          src="/artifacts/images/homepage/trust-customer-icons/infarm.webp"
          layout="responsive"
          width="103"
          height="25"
        />
      </Box>
    ),
    ebay: (
      <Box
        mx={{ xs: 4, lg: 5 }}
        my={2}
        width={62}
        height={{ xs: 13, md: 25 }}
        position="relative"
      >
        <CustomerLogo
          alt="The logo of Ebay"
          src="/artifacts/images/homepage/trust-customer-icons/ebay.webp"
          layout="responsive"
          width="62"
          height="25"
        />
      </Box>
    ),
    'hello-fresh': (
      <Box
        mx={{ xs: 4, lg: 5 }}
        my={2}
        width={{ xs: 44, md: 66 }}
        height={{ xs: 22, md: 32 }}
        position="relative"
      >
        <CustomerLogo
          alt="The logo of Hellofresh"
          src="/artifacts/images/homepage/trust-customer-icons/hellofresh.webp"
          layout="responsive"
          width="66"
          height="32"
        />
      </Box>
    ),
    audi: (
      <Box
        mx={{ xs: 4, lg: 5 }}
        my={2}
        width={{ xs: 47, md: 56 }}
        height={{ xs: 9, md: 20 }}
        position="relative"
      >
        <CustomerLogo
          alt="The logo of Audi"
          src="/artifacts/images/homepage/trust-customer-icons/audi.webp"
          layout="responsive"
          width="56"
          height="20"
        />
      </Box>
    ),
  };

  const customersToRender =
    items === 'all'
      ? Object.entries(customers)
      : Object.entries(customers).filter(([key]) =>
          items.includes(key as TrustedCustomer)
        );

  return (
    <div>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap={{ xs: 'wrap', md: 'nowrap' }}
        width={'100%'}
        maxWidth={{ xs: '80vw', md: 'none' }}
        mx="auto"
      >
        {customersToRender.map((customer) => customer[1])}
      </Box>
    </div>
  );
}

const CustomerLogo = styled(Image)`
  margin: ${(props) => props.theme.spacing(0, 10)};
`;

export default TrustedCustomers;
